import { StrictMode } from 'react'

import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'

import Settings from './settings'
import './locales/i18n'
import registerServiceWorker from './utils/service-worker-registration'
import { setupSettings } from './utils/settings'
import { router } from './views/router'

import './components/registrations'

// Initialise settings from settings.ts
setupSettings(Settings)

// Register service worker
if (import.meta.env.PROD) {
  registerServiceWorker()
}

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
